var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import MedicationOrSolutionDetailsCardAPI from './medication-or-solution-details-card-api';
import { ChemotherapyStatus, MedicationStatus } from './medication-or-solution-details-card-types';
import { MedicationDetails } from './medication-details';
import { SolutionDetails } from './solution-details';
import { ReactComponent as Checked } from '../../assets/images/global/checked.svg';
import { ReactComponent as CirclePause } from '../../assets/images/global/circle-pause.svg';
import { ReactComponent as CirclePlay } from '../../assets/images/global/circle-play.svg';
import { ReactComponent as ClockYellow } from '../../assets/images/global/clock-yellow.svg';
import { ReactComponent as PatientCheck } from '../../assets/images/global/patient-check.svg';
import { ReactComponent as PatientClock } from '../../assets/images/global/patient-clock.svg';
import { ReactComponent as PatientFirst } from '../../assets/images/global/patient-first.svg';
import { ReactComponent as PillCrusherClock } from '../../assets/images/global/pill-crusher-clock.svg';
import { ReactComponent as PillCrusherEye } from '../../assets/images/global/pill-crusher-eye.svg';
import { ReactComponent as LateIcon } from '../../assets/images/global/clock-orange.svg';
import './medication-or-solution-details-card.css';
let MedicationOrSolutionDetailsCard = class MedicationOrSolutionDetailsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { administrationRoute, breathingType, isChemotherapy, chemotherapyStatus, description, despisedVolumeQty, deviceDescription, dilution, doseQuantity, emarStepScheduleNumber, infusedVolumeQty, infusionSpeed, isSolution, itemQuantity, observation, onClick, orderSequence, prescriptionId, processNumber, qtOxygenFraction, respiratoryModality, statusDate, unitMeasureDoseCode, volumeInStepQty, side, topography, group, isDelayed } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        administrationRoute,
                        breathingType,
                        chemotherapyStatus,
                        description,
                        despisedVolumeQty,
                        deviceDescription,
                        dilution,
                        doseQuantity,
                        emarStepScheduleNumber,
                        group,
                        infusedVolumeQty,
                        infusionSpeed,
                        isChemotherapy,
                        isDelayed,
                        isSolution,
                        itemQuantity,
                        observation,
                        onClick,
                        orderSequence,
                        prescriptionId,
                        processNumber,
                        qtOxygenFraction,
                        respiratoryModality,
                        side,
                        statusDate,
                        topography,
                        unitMeasureDoseCode,
                        volumeInStepQty,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderItemTitle(icon, titleOne, titleTwo) {
        return (React.createElement("div", { className: 'c-medication-or-solution-details-card__description-name' },
            React.createElement("div", { className: 'c-medication-or-solution-details-card__pill-crusher-eye' }, icon),
            React.createElement("span", { className: 'c-medication-or-solution-details-card__description-name-text' }, titleOne || titleTwo)));
    }
    renderIcon(hourStatus, isDelayed = false) {
        switch (hourStatus) {
            case MedicationStatus.ADMINISTERED:
            case 'A':
                return React.createElement(Checked, null);
            case MedicationStatus.CHECKED_FIRST:
            case 'Q':
                return React.createElement(PatientFirst, null);
            case MedicationStatus.INTERRUPTED:
                return React.createElement(CirclePause, null);
            case 'N':
            case MedicationStatus.PENDING:
                return isDelayed ? React.createElement(LateIcon, null) : React.createElement(ClockYellow, null);
            case MedicationStatus.PENDING_REFUSAL:
            case 'J':
                return React.createElement(PatientClock, null);
            case MedicationStatus.PREPARATION:
            case 'P':
                return React.createElement(PillCrusherClock, null);
            case MedicationStatus.REFUSED_ADMINISTERED:
            case 'C':
                return React.createElement(PatientCheck, null);
            case MedicationStatus.STARTED:
                return React.createElement(CirclePlay, null);
            case 'L':
                return React.createElement(PillCrusherEye, null);
            default:
                return null;
        }
    }
    renderChemotherapyIcon(chemotherapyStatus, isDelayed = false) {
        switch (chemotherapyStatus) {
            case ChemotherapyStatus.PENDING: return isDelayed ? React.createElement(LateIcon, null) : React.createElement(ClockYellow, null);
            case ChemotherapyStatus.STARTED: return React.createElement(CirclePlay, null);
            case ChemotherapyStatus.ADMINISTERED: return React.createElement(Checked, null);
            case ChemotherapyStatus.CHECKED_FIRST: return React.createElement(PatientFirst, null);
            default: return null;
        }
    }
    renderDescriptionName() {
        const { description, materialDescription } = this.props;
        return this.renderItemTitle(this.getIconStatus(), description, materialDescription);
    }
    getIconStatus() {
        const { hourStatus, statusItem, chemotherapyStatus, isChemotherapy, isDelayed } = this.props;
        const statusItemValue = hourStatus || statusItem;
        if (this.shouldRenderChemotherapyIcon(isChemotherapy, chemotherapyStatus, statusItem)) {
            return this.renderChemotherapyIcon(chemotherapyStatus, isDelayed);
        }
        return this.renderIcon(statusItemValue, isDelayed);
    }
    shouldRenderChemotherapyIcon(isChemotherapy, chemotherapyStatus, statusItem) {
        const isChemotherapyAdministered = this.isChemotherapyAdministered(Boolean(isChemotherapy), chemotherapyStatus, statusItem);
        const isChemotherapyStarted = chemotherapyStatus === ChemotherapyStatus.STARTED;
        const notFirstCheck = statusItem !== MedicationStatus.CHECKED_FIRST;
        if (chemotherapyStatus == ChemotherapyStatus.CHECKED_FIRST || chemotherapyStatus == ChemotherapyStatus.PENDING) {
            return true;
        }
        return (isChemotherapyAdministered && isChemotherapy && (notFirstCheck || isChemotherapyStarted || !chemotherapyStatus)) || statusItem === ChemotherapyStatus.STARTED;
    }
    isChemotherapyAdministered(chemotherapy, chemotherapyStatus, statusItem) {
        return chemotherapy && !chemotherapyStatus && statusItem === MedicationStatus.ADMINISTERED;
    }
    render() {
        const { orderSequence, isSolution } = this.props;
        return (React.createElement(Card, { className: 'c-medication-or-solution-details-card', selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: orderSequence, width: 14 },
            React.createElement("div", { className: 'c-medication-or-solution-details-card__wrapper' },
                this.renderDescriptionName(),
                isSolution ? SolutionDetails(this.props) : MedicationDetails(this.props))));
    }
};
MedicationOrSolutionDetailsCard = __decorate([
    AwesomeComponent({ api: MedicationOrSolutionDetailsCardAPI, type: ComponentType.DATA_DISPLAY })
], MedicationOrSolutionDetailsCard);
export default MedicationOrSolutionDetailsCard;
//# sourceMappingURL=medication-or-solution-details-card.js.map